import { environment } from "./environment";

export const apiUrls = {
	accessToken: 		`${environment.api}/onboarding-web/security/auth`,
	publicRSAKey: 		`${environment.api}/onboarding-web/security/safe-data/generate/values`,
	referralSettings:	`${environment.api}/referral/v1.0.0/referral-settings`,
	validateCode:		`${environment.api}/Client/v1.0.0/validate-code`,
	codeOtp: 			`${environment.api}/Client/otp-1`,
	verifyOtp: 			`${environment.api}/Client/otp-2`,
	onboarding: 		`${environment.api}/Client/hybrid-security/onboarding`,
	onfido: 			`${environment.api}/security/hybrid-security/onfido-process`,
	getAccount:  		`${environment.api}/Client/hybrid-security/account`,
	updateProfile: 		`${environment.api}/Client`,
	address: 			`${environment.api}/Client/address`,
	financieInfo: 		`${environment.api}/Client/finance-info`,
	presignedUrl: 		`${environment.api}/Document`,
	cardInfo:			`${environment.api}/Client/card-info`,
	documents: 			`${environment.api}/Document/upload-document`,
	deleteDocuments: 	`${environment.api}/Document/document`,
	clientReview: 		`${environment.api}/Client/client-review`,
	appianProcess:      `${environment.api}/security/appian-process`,
	getProfile: 		`${environment.api}/Client/profile`,
	validateUser: 		`${environment.api}/Client/framework/cryptocustom/validateuserdata`,
	enrollUser: 		`${environment.api}/Client/v1.0.0/UserEnroll`,
};
